import { useLocation, useNavigate } from 'react-router-dom';
import { GUIDE_SURFACES } from '@features/knowledge-base/constants/featureLinks';
import { useFeatureLinksAccess } from '@features/knowledge-base/hooks/useFeatureLinksAccess';
import { useGuideDrawer } from '@features/knowledge-base/hooks/useGuideDrawer';
import { guideEntryState } from '@features/knowledge-base/utils/guideNavigation';

/** The controller supplies a validated /kb/{topic}/{id} path. */
export function usePulseReader() {
  const { enabled } = useFeatureLinksAccess({ logExposure: false });
  const drawer = useGuideDrawer();
  const location = useLocation();
  const navigate = useNavigate();

  return (path: string) => {
    if (enabled) {
      drawer.open({ slug: path.slice('/kb/'.length), surfaceId: GUIDE_SURFACES.PULSE });
    } else {
      navigate(path, { state: guideEntryState(location) });
    }
  };
}
